<template>
  <div>
    <v-dialog />
    <!--右侧内容-->
    <div class="class_add_top">
      <a class="back" onclick="history.go(-1)">返回</a>考卷打分 </div>
    <!--/右侧内容-->
    <div style="padding-left: 24px;padding-right: 32px;background: #ffffff;display: flex;flex-direction: row;justify-content: space-between">
      <div class="pingfen_left">
        <p class="pingfen_left_top">考卷题目数:<span class="pingfen_left_top_red"> {{questionCnt}} </span>题</p>
        <div class="pingfen_left_list">
          <p class="font14 colorBlack mb12">{{examPaperInfo.title}}</p>
          <p class="font14 colorBlack mb12" v-if="examQSelections.length > 0">单选题</p>
          <div v-if="examQSelections.length > 0" style="display: flex;flex-direction: row;margin-bottom: 28px;">
            <div @click="switchToQuestion(index, item.id)" class="grayDiv" :class="{'dui': item.isCorrect=='1', 'cuo': item.isCorrect=='0', '': (item.isCorrent == '0' && item.questionType == 'short')}" v-for="(item, index) in examQSelections" :key="item.id" style="cursor: pointer;">
              {{index+1}}
            </div>
          </div>
          <p class="font14 colorBlack mb12" v-if="examQMultiSelections.length > 0">多选题</p>
          <div v-if="examQMultiSelections.length > 0" style="display: flex;flex-direction: row;margin-bottom: 28px;">
            <div @click="switchToQuestion(index, item.id)" class="grayDiv" :class="{'dui': item.isCorrect=='1', 'cuo': item.isCorrect=='0', '': (item.isCorrent == '0' && item.questionType == 'short')}" v-for="(item, index) in examQMultiSelections" :key="item.id" style="cursor: pointer;">
              {{index+1}}
            </div>
          </div>
          <p class="font14 colorBlack mb12" v-if="examQJudgements.length > 0">判断题</p>
          <div v-if="examQJudgements.length > 0" style="display: flex;flex-direction: row;margin-bottom: 28px;">
            <div @click="switchToQuestion(index, item.id)" class="grayDiv" :class="{'dui': item.isCorrect=='1', 'cuo': item.isCorrect=='0', '': (item.isCorrent == '0' && item.questionType == 'short')}" v-for="(item, index) in examQJudgements" :key="item.id" style="cursor: pointer;">
              {{index+1}}
            </div>
          </div>
          <p class="font14 colorBlack mb12" v-if="examQWrites.length > 0">填空题</p>
          <div v-if="examQWrites.length > 0" style="display: flex;flex-direction: row;margin-bottom: 28px;">
            <div @click="switchToQuestion(index, item.id)" class="grayDiv" :class="{'dui': item.isCorrect=='1', 'cuo': item.isCorrect=='0', '': (item.isCorrent == '0' && item.questionType == 'short')}" v-for="(item, index) in examQWrites" :key="item.id" style="cursor: pointer;">
              {{index+1}}
            </div>
          </div>
          <p class="font14 colorBlack mb12" v-if="examQShorts.length > 0">简单题</p>
          <div v-if="examQShorts.length > 0" style="display: flex;flex-direction: row;margin-bottom: 28px;">
            <div @click="switchToQuestion(index, item.id)" class="grayDiv" :class="{'dui': item.isCorrect=='1', 'cuo': item.isCorrect=='0', '': (item.isCorrent == '0' && item.questionType == 'short')}" v-for="(item, index) in examQShorts" :key="item.id" style="cursor: pointer;">
              {{index+1}}
            </div>
          </div>
        </div>
      </div>
      <div class="pingfen_right">
        <div class="pingfen_right_one mb24" v-if="question && question.questionInfoList">
          <p class="mt25 font18 colorBlack mb24 fontweight" v-if="question.questionType !== 'write'">
            <span class="font24 colorBlack fontweight">{{questionIndex+1}}. </span>{{question.questionInfoList.description}}<span class="colorBlue">({{question.questionTypeLabel}})</span>
          </p>
          <p class="font14 colorBlack mb25 displayFlex" v-if="question.questionType == 'selection'" v-for="item in question.answerInfoList" :key="item.id">
            <input type="radio" name="timu" :id="item.id" :value="item.no" v-model="selectOption" disabled/><span class="marginSpan">{{String.fromCharCode(65 + parseInt(item.no))}}.</span> {{item.description}}
          </p>
          <p class="font14 colorBlack mb25 displayFlex" v-if="question.questionType == 'multiSelection'" v-for="item in question.answerInfoList" :key="item.id">
            <input type="checkbox" style="opacity: 1;" name="timu" :id="item.id" :value="item.no" v-model="multiSelectOption" disabled/><span class="marginSpan">{{String.fromCharCode(65 + parseInt(item.no))}}.</span> {{item.description}}
          </p>
          <p class="font14 colorBlack mb25 displayFlex" v-if="question.questionType == 'judgement'" v-for="item in question.answerInfoList" :key="item.id">
            <input type="radio" name="timu" :id="item.id" :value="item.no" v-model="selectOption" disabled/><span class="marginSpan">{{String.fromCharCode(65 + parseInt(item.no))}}.</span> {{item.description}}
          </p>
          <p class="font14 colorBlack mb25 displayFlex" v-if="question.questionType == 'short'">
            <textarea class="text_con" placeholder="提交答案" v-model="shortAnswer" readonly></textarea>
          </p>
          <p class="mt25 font18 colorBlack mb24 fontweight" v-if="question.questionType == 'write'">
            <span class="font24 colorBlack fontweight">{{questionIndex+1}}. </span>{{question.infoAnswer}}<span class="colorBlue">({{question.questionTypeLabel}})</span>
          </p>
        </div>
        <div class="pingfen_right_one pl43">
          <p class="font18 colorBlack fontweight mb18">答案解析：</p>
          <div class="pingfen_right_Two mb24">
            <p class="font14 colorGreen mb12" v-if="question.questionType=='short' || question.questionType=='write'">正确答案：&nbsp;<span class="redColor">{{question.answer}}</span></p>
            <p class="font14 colorGreen mb12" v-if="question.questionType=='selection' || question.questionType=='judgement'">正确答案：&nbsp;<span class="redColor">{{String.fromCharCode(65 + parseInt(question.answer))}}</span></p>
            <p class="font14 colorGreen mb12" v-if="question.questionType=='multiSelection'">正确答案：&nbsp;<span class="redColor">{{AscToString(question.answer)}}</span></p>
            <p class="font12 colorBlack lineHeight24" v-if="question.thinkingInfoList && question.thinkingInfoList.description">试题评析：{{question.thinkingInfoList.description}}</p>
            <img v-if="question.thinkingInfoList && question.thinkingInfoList.uri" :src="question.thinkingInfoList.uri" alt="">
          </div>
        </div>
        <div class="pingfen_right_one pl43 pt20 pb20" style="display: flex;justify-content: space-between;border: none;">
          <p class="red_font font14">此题分值：{{question.point}}分题</p>
          <p>
            <input name="time" type="radio" value="1" v-model="question.isCorrect" />
            正确
            <input name="time" type="radio" value="0" v-model="question.isCorrect" />
            不正确
          </p>
          <div style="display: flex;align-items: center;">
            老师打分:
            <input type="text" placeholder="0" class="pingfen_num" v-model="question.infoScore">
            分
          </div>
        </div>
        <!--div class="pl43">
          <textarea type="text" placeholder="老师批注" class="pingfen_right_Three font14 colorBlack"></textarea>
        </div-->
        <span class="pingfen_a" @click="rate(question)" style="cursor: pointer;">打分</span>
      </div>
    </div>
  </div>
</template>
<script>
  import utils from '@/utils'
export default {
  components: {},
  data () {
    return {
      examId: this.$route.params.examId,
      paperId: this.$route.params.paperId,
      examPaperInfo: {},
      examPaperQInfo: [],
      examQSelections: [], // 单选题题目集
      examQMultiSelections: [], // 多选题题目集
      examQJudgements: [], // 判断题题目集
      examQShorts: [], // 简答题题目集
      examQWrites: [], // 填空题题目集
      question: {}, // 当前题目
      questionIndex: 0,
      questionCnt: 0, // 题目总数
      selectOption: '', // 单选题目答案
      multiSelectOption: [], // 多选题目答案
      shortAnswer: '' // 简答题答案
    }
  },
  created () {
    this.getExamPaper(this.paperId, this.examId).then((r) => {
      if (r) { this.examPaperInfo = r } else { this.examPaperInfo = {} }
    })
    this.init() // 初始化第一道题
  },
  computed: {},
  methods: {
    confirmBox (o) {
      var that = this
      this.$modal.show('dialog', {
        title: '提交',
        text: '确认提交吗？',
        buttons: [
          {
            title: '确认',
            default: false,
            handler: utils.debounce(() => {
              if (o.yes && o.yes instanceof Function) {
                o.yes()
                that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
              }
            }, 1000)
          },
          {
            title: '取消'
          }
        ]
      })
    },
    getExamPaper (id, examId) { // 取考卷信息
      return new Promise((resolve, reject) => {
        this.$api.post(this.$global.examApiPath, '/examPaper/getByExam', {id: id, examId: examId}, r => {
          resolve(r.data)
        })
      })
    },
    getQuestionResults (examId) {
      return new Promise((resolve, reject) => {
        this.$api.post(this.$global.examApiPath, '/examExamScoreInfo/search', {examId: examId}, r => {
          resolve(r.data)
        })
      })
    },
    getQuestionAnswers (infoId) {
      return new Promise((resolve, reject) => {
        this.$api.post(this.$global.examApiPath, '/examQuestion/getByExam', {infoId: infoId, getAnswer: '1'}, r => {
          resolve(r.data)
        })
      })
    },
    dealAnswer (type, answer, writeStr) {
      switch (type) {
        case 'selection':
          this.selectOption = answer
          return answer
          break;
        case 'multiSelection':
          this.multiSelectOption = answer.split('');
          return answer.split('');
          break;
        case 'judgement':
          this.selectOption = answer
          return answer
          break;
        case 'short':
          this.shortAnswer = answer
          return answer
          break;
      }
    },
    AscToString (arr) {
      var answerStr = ''
      var arr_sort = arr.slice(0)
      for (let i=0; i<arr_sort.length; i++) {
        answerStr += String.fromCharCode(65 + parseInt(arr_sort[i]))
      }
      return answerStr
    },
    switchToQuestion (index, infoId) { //  获取单个题目
      this.questionIndex = index
      this.getQuestionAnswers(infoId).then((r) => {
        this.question = r
        if (this.question.questionType == 'write') {
          let answer = this.dealAnswer(this.question.questionType, this.question.infoAnswer, this.question.questionInfoList.description)
        } else {
          let answer = this.dealAnswer(this.question.questionType, this.question.infoAnswer)
        }
      })
    },
    splitQuestions (arr) {
      var _g = function (t) {
        return arr.filter((o) => {
          return o.questionType == t
        })
      }
      this.examQSelections = _g('selection')
      this.examQMultiSelections = _g('multiSelection')
      this.examQJudgements = _g('judgement')
      this.examQShorts = _g('short')
      this.examQWrites = _g('write')
    }, // 分组
    rate (params) { // 打分
      let p = {
        examId: this.$route.params.examId,
        id: params.infoId,
        isCorrect: params.isCorrect,
        paperId: this.$route.params.paperId,
        questionId: params.id,
        score: params.infoScore
      }
      var self = this
      this.confirmBox({
        yes: function () {
          return new Promise((resolve, reject) => {
            self.$api.post(self.$global.examApiPath, '/examExamScoreInfo/saveByTeacher', p, r => {
              resolve(r.data)
              self.init()
            })
          })
        }
      })
    },
    init () {
      this.getQuestionResults(this.examId).then((r) => {
        if (r) {
          this.questionCnt = r.length
          if (r && r.length>0) {
            this.examPaperQInfo = r
            this.switchToQuestion(0, this.examPaperQInfo[0].id)
            this.splitQuestions(this.examPaperQInfo)
          } else {
            this.examPaperQInfo = []
          }
        }
      })
    }
  }
}
</script>
<style lang="scss">
  .grayDiv.dui { background: #298d0e; color: white; }
  .grayDiv.cuo { background: #ff3633; color: white; }
</style>



// WEBPACK FOOTER //
// src/page/byl/org/examination_paper/scoreByTeacher.vue